module.exports = __webpack_public_path__ + "img/archive.11aed805.svg";